<div class="login-container">
  <div class="login-form">
    <h2 class="login-title">Sign in</h2>
    <p class="login-error" *ngIf="signInFailed" role="alert">
      Sign-in did not finish. Try again on the Beyond Multiple Choice site.
    </p>
    <p class="login-help" *ngIf="!signInFailed">
      Use your Beyond Multiple Choice account.
    </p>
    <button type="button" class="submit-btn" (click)="signIn()">Sign in</button>
  </div>
</div>
